<template>
  <div>
    <v-icon color="grey accent-4" @click="mostrarModal=true">mdi-dots-horizontal-circle</v-icon>
    <v-dialog v-model="mostrarModal" transition="dialog-bottom-transition" fullscreen persistent>
      <!-- <v-container fluid class="white elevation-3 margen d-flex justify-space-around">
          <h1>Órdenes de compra</h1>
          <v-btn class="mt-2 success" to="/NuevaOrdenCompra">Detalle Orden de compra.</v-btn>
      </v-container> -->
      <v-card>
        <!-- TOOLBAR -->
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="mostrarModal=false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Orden de compra</v-toolbar-title>
          <v-spacer/>
          <v-toolbar-items> <v-btn
              dark
              text
              @click="mostrarModal=false"
            >
              Salir
            </v-btn> </v-toolbar-items>
        </v-toolbar>
        <!-- TERMINA TOOLBAR -->
        <v-card class="ma-3 allB" >
          <v-card-title>Datos: </v-card-title>
          <div class="mx-3">
            <!-- <v-text-field label="Orden de Compra" v-model="ordenCompra" filled/> -->
            <v-text-field label="Orden de Venta" v-model="ordenVenta" filled/>
          </div>
          <div style="margin: 0px !important">
            <v-data-table
            :headers="columnasArts"
            :items="articulos"
            :search="buscador"
            :loading="cargando"
            class="allB"
            :item-class="itemRowBackground"
            >
          
              <template v-slot:[`item.ESTATUS`]="{ item }">
                {{estatusItem(item.ESTATUS)}}
              </template>

              <template v-slot:[`item.FECHA_ENTREGA`]="{ item }">
                {{formatoFecha(item.FECHA_ENTREGA)}}
              </template>

              <template slot="no-data">
                <v-alert class="my-2" :value="true" type="info" color="orange lighten-2" >
                  No se encontró información para mostrar.
                </v-alert>
              </template>

              <template v-slot:[`item.actionFechaEntrega`]="{ item }">
              <!-- <template > -->
                <v-menu v-model="item.modalFecha" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
                offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="item.FECHA_ENTREGA"
                    light readonly v-bind="attrs" v-on="on" class="mx-3"/>
                  </template>
                  <v-date-picker v-model="item.FECHA_ENTREGA" @input="item.modalFecha = false" :min="fechaMin"/>
                </v-menu>
              </template>

              <template v-slot:[`item.actionEntregado`]="{ item }">
                <div>
                  <ModalArticuloEntregado
                  :infoArticulo ="item"
                  @actualizarTabla ="obtenerOrdenes"
                  :key="item.ORDEN_ID"/>
                </div>
              </template>

              <template v-slot:[`item.actionCantRecibida`]="{ item }">
                <div>
                  <v-text-field label="Cantidad recibida" v-model="item.CANTIDAD_RECIBIDA" :min="item.CANTIDAD_MINIMA" :max="item.CANTIDAD" type="number" dense solo hide-details="" />
                </div>
              </template>
              <template v-slot:footer>
                <div v-if="articulos.length > 0" class="d-flex justify-end ml-auto align-center" style="width:50%;">
                  <span class="mx-2">Subtotal: </span>
                  <v-text-field :value="'$'+total" class="font-weight-regular" style="max-width:fit-content;" readonly/>
                </div>
                </template>
            </v-data-table>
          </div>
        <v-card-actions class="d-flex justify-space-around" v-if="mostrarBotones">
          <v-btn small class="grey darken-2" dark @click="mostrarModal=false"> Cancelar</v-btn>
          <v-btn small class="primary darken-2" dark @click="guardarCambios" :loading="btncargando"> Guardar Cambios</v-btn>
        </v-card-actions>
        </v-card>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import ModalArticuloEntregado from './ModalArticuloEntregado'
export default {
  components: {ModalArticuloEntregado},
  props:['infoOrden'],
  data() {
    return{
      cargando: false,
      articulos:[],
      mostrarModal: false,
      ordenCompra:'',
      ordenVenta:'',
      buscador:'',
      btncargando : false,
      total: 0,
      fechaMin: '',

      columnasArts:[
        {text:"Nombre",value:"NOMBRE"},
        {text:"Clave MSP", value:"CLAVE_MSP"},
        //{text:"Fecha de entrega",value:"FECHA_ENTREGA"},
        {text:"Fecha de entrega", value:"actionFechaEntrega", width:"100%"},
        {text:"Precio",value:"PRECIO_ORIGINAL"},
        {text:"Cantidad",value:"CANTIDAD"},
        {text:"Cantidad entregada",value:"actionCantRecibida"},
        {text:"Descuento 1",value:"DESCUENTO1"},
        {text:"Descuento 2",value:"DESCUENTO2"},
        {text:"Precio C/Desc.",value:"PRECIO_DESCUENTO"},
        {text:"Estatus",value:"ESTATUS"},
        {text:"Entregado",value:"actionEntregado"}
      ],
    }
  },
  computed: {
      ...mapGetters(['getURLAPI','getUsuario','getFechaActual']),

      mostrarBotones: function(){
      if(//this.ordenCompra != '' || 
      this.ordenVenta != ''){
        return true;
      }
      else {
        return false;
      }
    },
  },
  methods:{
    // ----------------------------------------------------------------------------------------------
    obtenerOrdenes( )
    {
      this.cargando  = true;
      axios.get(`${this.getURLAPI}/Ordenes/getOrdenesDetalle/${this.infoOrden.ORDEN_COMPRA_ID}`)
      .then( ( { data } ) => 
      {
        if (data && data.length > 0) 
        {
          // console.log(data, this.infoOrden);
          this.articulos = [];
          this.articulos = data;
          this.articulos.forEach( (articulo) => {
            articulo.FECHA_ENTREGA = this.formatoFecha(articulo.FECHA_ENTREGA);
            articulo.CANTIDAD_MINIMA = articulo.CANTIDAD_RECIBIDA;
            let precioDescuento1 = articulo.PRECIO * ((100 - articulo.DESCUENTO1)/100);
            let precioDescuento2 = precioDescuento1 * ((100 - articulo.DESCUENTO2)/100);            
            let precioFormato = precioDescuento2.toFixed(2);
            let precioFormato2 = ((parseFloat(precioFormato))*articulo.CANTIDAD).toLocaleString("en-US",{ minimumFractionDigits: 2 });
            //console.log(precioFormato2.toLocaleString());
            //console.log(precioFormato2);
            // console.log((precioFormato+0).toLocaleString());
            let precioO = parseFloat(articulo.PRECIO);
            precioO = precioO.toFixed(2);

            articulo.PRECIO_ORIGINAL = parseFloat(precioO).toLocaleString("en-US",{ minimumFractionDigits: 2 });
            articulo.PRECIO_FORMATO = parseFloat(precioFormato);
            articulo.PRECIO_DESCUENTO = precioFormato2;
          })
          this.calcularTotales();
          this.ordenVenta = this.infoOrden.ORDEN_VENTA;

        }
      })
      this.cargando = false;
    },

    estatusItem(estatus)
    {
      let mensaje;

      switch(estatus){
        case "A":
          mensaje = "Activo";
          break;
        case "E":
          mensaje = "Entregado";
          break;
        case "P":
          mensaje = "Pendiente";
          break;
      }

      return mensaje;
    },

    calcularTotales(){
      let totalF = 0;
      this.total = 0;
      let resultado = 0;
      this.articulos.forEach( (articulo) =>{  
        resultado += (articulo.PRECIO_FORMATO * articulo.CANTIDAD);
      })
      totalF = resultado.toFixed(2);
      this.total = (parseFloat(totalF)).toLocaleString("en-US",{ minimumFractionDigits: 2 });
    },

    formatoFecha(fechaEntrega)
    {
      let fechaEntregaFormateada;
      fechaEntregaFormateada = fechaEntrega.slice(0,-9);

      return fechaEntregaFormateada;
    },

    // ----------------------------------------------------------------------------------------------
    itemRowBackground: function (item) {
     return item.ESTATUS == 'E' ? 'style-1' : '';
    },

    // ----------------------------------------------------------------------------------------------
    guardarCambios(){
      this.btncargando = true;
      let datosForm = new FormData();
      // datosForm.append("ORDEN_COMPRA", this.ordenCompra);
      console.log("Guardar cambios");
      console.log(this.articulos);
      datosForm.append("ORDEN_VENTA", this.ordenVenta);
      datosForm.append("USUARIO_MODIFICADOR", this.getUsuario);
      datosForm.append("ORDEN_COMPRA_ID", this.infoOrden.ORDEN_COMPRA_ID);
      datosForm.append("ARTICULOS", JSON.stringify(this.articulos));

      axios.post(`${this.getURLAPI}/Ordenes/asignarOrdenCompra`,datosForm)
      .then( ({data}) => {
        console.log(data);
        this.obtenerOrdenes();
        this.btncargando = false;
        this.$root.vtoast.show({ 
                  message: data.MSG,  color: data.STATUS=="OK" ? 'success darken-2':'red darken-2', 
                  timer:10000,        icon: data.STATUS=="OK" ? 'mdi-check':'mdi-alert-circle-outline' } 
              )
      })
      .catch( () =>{
        this.btncargando = false
        this.$root.vtoast.show(
                { message: "Error con el servidor",  color:'red darken-2', 
                  timer:10000,        icon: 'mdi-alert-circle-outline' } 
            )
      }) 
    }
  },

  created() {
    this.obtenerOrdenes();
    // this.fechaActual();
    this.fechaMin = this.getFechaActual.split(" ")[0]
    //this.calcularTotales();
    // console.log(this.infoOrden.FOLIO,this.infoOrden);

  }
}
</script>

<style>
.style-1 {
  background-color: rgb(141, 196, 109)
}

.style-1:hover{
  background-color: rgb(133, 181, 105)!important
}
</style>